import { render } from "./Perfil.vue?vue&type=template&id=11b15b08&scoped=true"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"

import "./Perfil.vue?vue&type=style&index=0&id=11b15b08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b15b08"]])

export default __exports__